(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xg002-before-after-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const roots = document.querySelectorAll('[data-xg002-before-after]');

    roots.forEach((root) => {
      if (root.dataset.initialized === 'true') {
        return;
      }

      root.dataset.initialized = 'true';

      const track = root.querySelector('.xg002-before-after__track');
      const slides = Array.from(root.querySelectorAll('.xg002-before-after__slide'));
      const dots = Array.from(root.querySelectorAll('[data-xg002-dot]'));
      const previousButton = root.querySelector('[data-xg002-prev]');
      const nextButton = root.querySelector('[data-xg002-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentIndex = 0;
      let timer = null;

      const goTo = (index) => {
        currentIndex = (index + slides.length) % slides.length;
        track.style.transform = `translateX(-${currentIndex * 100}%)`;
        dots.forEach((dot, dotIndex) => {
          dot.classList.toggle('is-active', dotIndex === currentIndex);
        });
      };

      const stop = () => {
        if (timer) {
          window.clearInterval(timer);
          timer = null;
        }
      };

      const start = () => {
        if (reducedMotion || slides.length < 2 || root.dataset.autoplay === 'false') {
          return;
        }

        stop();
        timer = window.setInterval(() => goTo(currentIndex + 1), Number(root.dataset.interval || 4500));
      };

      if (previousButton) {
        previousButton.addEventListener('click', () => {
          goTo(currentIndex - 1);
          start();
        });
      }

      if (nextButton) {
        nextButton.addEventListener('click', () => {
          goTo(currentIndex + 1);
          start();
        });
      }

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          goTo(Number(dot.dataset.xg002Dot));
          start();
        });
      });

      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', start);
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stop();
        } else {
          start();
        }
      });

      goTo(0);
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
